angular.module('sharecrf.unknown-value', ['ecrd'])
    .run(['$rootScope', 'UNKNOWN_VALUE', function($rootScope, UNKNOWN_VALUE) {
        // eslint-disable-next-line angular/no-run-logic
        $rootScope.UNKNOWN_VALUE = UNKNOWN_VALUE;
    }]);
